import { render, staticRenderFns } from "./ViewButton.vue?vue&type=template&id=be9fb90a&scoped=true&"
import script from "./ViewButton.vue?vue&type=script&lang=js&"
export * from "./ViewButton.vue?vue&type=script&lang=js&"
import style0 from "./ViewButton.vue?vue&type=style&index=0&id=be9fb90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9fb90a",
  null
  
)

export default component.exports